import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
import firebase from './../Firestore'
import { Link } from 'react-router-dom';
import FileUploader from "react-firebase-file-uploader";
import NavBar from './NavBar'

import config from 'react-global-configuration';


//import CategoriaSelector from './CategoriaSelector'

class CategoriaCreate extends Component {

  categoriaID = React.createRef();

  constructor() {
    super();

    this.ref = firebase.firestore().collection('categoria');
    this.state = {
      nombre: '',
      imagen: '',
      orden: '',
      seFracciona: 0,
      diseno: 'generico'
    };
  }


  onChange = (e) => {
    //console.log("ref", this.categoriaID.current.value)

        const state = this.state
        state[e.target.name] = e.target.value;
        this.setState(state);

  }

  onSubmit = (e) => {
    e.preventDefault();
    //console.log("precios", e.currentTarget)

    //return



    const { nombre, imagen, orden, seFracciona, diseno } = this.state;

    this.ref.add({
      nombre,
      imagen: this.state.imagenURL !== undefined ? this.state.imagenURL : "",
      orden: Number(this.state.orden),
      seFracciona: Boolean(this.state.seFracciona),
      diseno
    }).then((docRef) => {
      this.setState({
        nombre: '',
        imagen: '',
        imagenURL: '',
        orden: '',
        seFracciona: '',
        diseno: ''
      });
      this.props.history.push("/admin/categoria/lista")
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }


  //handleChangeUsername = event =>
      //this.setState({ username: event.target.value });
    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => {
      this.setState({ isUploading: false });
      console.error(error);
    };
    handleUploadSuccess = filename => {
      this.setState({ imagen: filename, progress: 100, isUploading: false });
      firebase
        .storage()
        .ref("categorias")
        .child(filename)
        .getDownloadURL()
        .then(url => this.setState({ imagenURL: url }));
    };

  render() {
    const { nombre, imagen, orden, seFracciona, diseno } = this.state;
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              AGREGAR CATEGORIA
            </h3>
          </div>
          <div className="panel-body">
            <form onSubmit={this.onSubmit}>
              <div className="form-group">

                <label htmlFor="nombre">Nombre de la nueva categoria:</label>
                <input type="text" className="form-control" name="nombre" value={nombre} onChange={this.onChange} placeholder="Nombre" required />
              </div>

                <span calssName="d-block mt-2">Imagen de la categoria (ideal 400px ancho x 100px alto):</span><br/>
                {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
                {this.state.imagenURL && <img src={this.state.imagenURL} alt={this.state.nombre} />}
                <FileUploader
                  accept="image/*"
                  name="categoria"
                  randomizeFilename
                  storageRef={firebase.storage().ref("categorias")}
                  onUploadStart={this.handleUploadStart}
                  onUploadError={this.handleUploadError}
                  onUploadSuccess={this.handleUploadSuccess}
                  onProgress={this.handleProgress}
                  maxHeight="100"
                  maxWidth="400"
                />

              <div className="form-group mt-2">
                  <label htmlFor="orden">Orden:</label>
                  <input type="number" className="form-control" name="orden" value={orden} onChange={this.onChange} placeholder="Orden" />
                </div>


              <select value={seFracciona} name="seFracciona" onChange={this.onChange} className="custom-select mt-2">
                <option value={false}>No se Fracciona</option>
                <option value={true}>Se fracciona</option>
              </select>


              <label htmlFor="diseno">Diseño para mostrar los productos de esta categoria:</label>
              <select value={diseno} name="diseno" onChange={this.handleChange} className="custom-select mt-2">
                <option value="generico">Lista de productos genericos</option>
                <option value="empanada">Lista de empanadas</option>
                <option value="pizza">Formato para pizzas</option>
              </select>


              <button type="submit" className="btn btn-success mt-2">Agregar categoria</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoriaCreate;
